export const formatCardNumber = (cardNumber?: string) => {
  if (!cardNumber) return "-";
  return `**** **** **** ${cardNumber.slice(-4)}`;
};
